import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
// core components
import Header from "../../../../components/Headers/BasicHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getGroup, postGroup, putGroup } from "network/ApiAxios";
import AccountInformation from "./AccountInformation";
import GroupInformation from "./GroupInformation";
import ManagementInformation from './ManagementInformation';
import BasicModal from '../../../../components/Modals/BasicModal'
import {validateData} from '../../../../utils/views/pages/Dynamics'
import secureLocalStorage from "react-secure-storage";

const Profile = (props) => {

    const navigate = useNavigate();
    const params = useParams()
    const [group, setGroup] = useState({});
    const [groupLoaded, setGroupLoaded] = useState(false); // Novo estado específico
    const formDisabled = (props.action == "view")
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalGoTo, setModalGoTo] = useState()
    const [isLoading, setisLoading] = useState(false)    
    const [teachersOptions, setTeachersOptions] = useState([])
    const [studentsOptions, setStudentsOptions] = useState([])
    const [showInstitutions, setShowInstitutions] = useState(false)
    const [showTeachers, setShowTeachers] = useState(true)
    const [showStudents, setShowStudents] = useState(true)
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const validations = {
        name: '',
        institution: '',
        students: '',
        users: {alias: "Teachers", pattern: ''},
    }

    useEffect(() => {

        setGroup({});
        setGroupLoaded(false);
        setTeachersOptions([]);
        setStudentsOptions([]);
        setShowInstitutions(false);
        setShowTeachers(true);
        setShowStudents(true);
        
        const runAsync = async () => {
            const response = await getGroup(params.id);
            const { data } = response;

            if (data.success) {
                setGroup(data.group);
                setGroupLoaded(true);
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }
            
        }

        if (props.action != "create") {
            runAsync();
        }

    }, [params.id, props.action]);

    let sendData = () => {

        const runAsync = async () => {

            let response = ''
            
            if(props.action=="create"){
                group.account = user.account
                response = await postGroup(group);
            }else if(props.action=="edit"){
                group.id = params.id                
                response = await putGroup(group);
            }
            
            const { data } = response;
            
            if (data.success) {
                setModalTitle("Information")
                setModalMessage(data.msg)
                setShowModal(true)
                setModalGoTo('/admin/groups')
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }

            setisLoading(false);
        }
        
        runAsync();
    }
    
    let mountAccountInformation = () => {

        if (props.action == "create")
            return <></>
        else {
            return (
                <AccountInformation
                    group={group}
                    formDisabled={true} />
            )
        }
    }   

    let handleSubmit = () => {
        if (validateData(validations, group, setModalTitle, setModalMessage, setShowModal)) {            
            setisLoading(true);
            sendData()
        }
    }

    return (
        <>
            <Header />
            {/* Page content */}

            <Container className="border-0 pb-0 pt-0 pt-md-3" fluid>
                <Row>

                    <Col className="order-xl-1" >
                        <Card className=" shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8" className="text-left">
                                        <Button onClick={() => navigate('/admin/groups')}
                                            className="btn-back" type="button">

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-bold-left" />
                                            </span>

                                            <span className="btn-inner--text h3 mb-0">Group's Profile</span>

                                        </Button>
                                        
                                    </Col>

                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>

                                    <GroupInformation
                                        group={group}
                                        groupLoaded={groupLoaded} //Passar se o grupo foi carregado para verificar se pode montar 
                                        action={props.action}
                                        formDisabled={formDisabled || isLoading}
                                        setStudentsOptions={setStudentsOptions}
                                        setTeachersOptions={setTeachersOptions}
                                        setGroup={setGroup}
                                        showInstitutions={showInstitutions}
                                        setShowInstitutions={setShowInstitutions}
                                        setShowStudents={setShowStudents}
                                        setShowTeachers={setShowTeachers}
                                        validations={validations} />

                                    <hr className="my-4" />

                                    <ManagementInformation
                                        group={group}
                                        formDisabled={formDisabled || isLoading}
                                        studentsOptions={studentsOptions}
                                        teachersOptions={teachersOptions}
                                        setGroup={setGroup}
                                        showInstitutions={showInstitutions}
                                        showStudents={showStudents}
                                        showTeachers={showTeachers}
                                        validations={validations} />

                                    {mountAccountInformation()}

                                    <hr className="my-4" />

                                    <Row className="align-items-left">
                                        <Col className="text-left" xs="4">

                                            <Button onClick={() => navigate('/admin/groups')}
                                                className="btn-icon btn-3" color="primary" type="button">

                                                <span className="btn-inner--icon">
                                                    <i className="ni ni-bold-left" />
                                                </span>

                                                <span className="btn-inner--text">Back</span>

                                            </Button>

                                        </Col>

                                        {
                                            function () {
                                                return (

                                                    props.action == "view" ? "" :

                                                        <Col className="text-right" xs="8">
                                                            <Button onClick={handleSubmit}
                                                                className="btn-icon btn-3" color="success" type="button"
                                                                disabled={isLoading}
                                                            >
                                                                
                                                                
                                                                {isLoading ? (

                                                                    <Spinner size="sm" className="me-2 mx-1" />
                                                                ) : 
                                                                
                                                                (
                                                                    <>
                                                                        <span className="btn-inner--icon">
                                                                            <i className="ni ni-check-bold" />
                                                                        </span>

                                                                        <span className="btn-inner--text">Confirm</span>
                                                                    </>
                                                                )}

                                                                
                                                            </Button>
                                                        </Col>
                                                )
                                            }()
                                        }

                                    </Row>

                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <BasicModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                handleGoTo={modalGoTo} />
        </>
    );
}

export default Profile;
